import { siteStats } from "@/mocks/home";

export default function StatsStrip() {
  return (
    <section className="w-full bg-foreground-950">
      <div className="px-4 py-10 md:px-6 md:py-12 lg:px-8">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {siteStats.map((stat) => (
            <div
              key={stat.id}
              className="flex flex-col gap-3 border-background-50/10 lg:border-r lg:pr-8 lg:last:border-r-0"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className={`${stat.icon} text-lg`} />
              </span>
              <div>
                <p className="font-heading text-2xl font-black text-background-50 md:text-3xl">
                  {stat.value}
                  <span className="ml-1 text-xs font-medium text-background-100/60">{stat.unit}</span>
                </p>
                <p className="mt-1 text-xs font-medium tracking-wide text-background-100/60 md:text-sm">
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}